<template>
  <div v-bind:class="styles" :style="transformStyles">
    <div class="c-selection-card__content">
      <div class="image">
        <img v-bind:src="img" :alt="imgAlt" />
      </div>
      <div class="title-container">
        <h2 :id="`selectionCard-${id}_title`" class="title h4">{{title}}</h2>
      </div>
    </div>

    <transition name="selection-card-hover">
      <div :class="{'c-selection-card__overlay': true}">
        <div class="title">{{title}}</div>
        <p class="description" v-html="description"></p>
        <div class="actions">
          <button
            class="btn btn-round btn-danger"
          >{{selected ? removeButtonText : buttonText | upper}}</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: window.location.href,
      isSelected: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      default: "",
    },
    imgAlt: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    flags: {
      type: String,
      default: "",
    },
    categoryTitle: {
      type: String,
      default: "",
    },
    mediaTitle: {
      type: String,
      default: "",
    },
    mediaText: {
      type: String,
      default: "",
    },
    mediaLink: {
      type: String,
      default: "",
    },
    mediaLinkClass: {
      type: String,
      default: "",
    },
    mediaLinkTarget: {
      type: String,
      default: "",
    },
    mediaLinkDescription: {
      type: String,
      default: "",
    },
    downloadLink: {
      type: String,
      default: "",
    },
    downloadLinkClass: {
      type: String,
      default: "",
    },
    downloadLinkTarget: {
      type: String,
      default: "",
    },
    downloadButtonText: {
      type: String,
      default: "Download Your Tookit",
    },
    tabindex: {
      type: Number,
    },
    active: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "select",
    },
    removeButtonText: {
      type: String,
      default: "deselect",
    },
    selected: {
      type: Boolean,
      default: false,
    },
    boxShadow: {
      type: Boolean,
      default: false,
    },
    rotate: {
      type: Number,
    },
    skew: {
      type: Number,
    },
    sortOrder: {
      type: String,
    },
  },
  mounted() {
    // if(this.active) {
    //     this.$refs.button.focus()
    // }
  },
  filters: {
    upper: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  computed: {
    styles() {
      return {
        "c-selection-card": true,
        selected: this.selected,
        hover: this.active,
        "box-shadow": this.boxShadow,
      };
    },

    transformStyles() {
      let transforms = [];
      if (this.rotate) {
        transforms.push(`rotate(${this.rotate}deg)`);
      }
      if (this.skew) {
        transforms.push(`skew(${this.skew}deg)`);
      }
      return transforms.length > 0
        ? { transform: `${transforms.join(" ")}` }
        : null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-selection-card.vue